type RelativeTimeProps = {
    className?: string;
    date: number;
};

export default function RelativeTime(props: RelativeTimeProps) {
    const { date, className } = props;

    // in miliseconds
    const units: any = {
        day: 24 * 60 * 60 * 1000,
        hour: 60 * 60 * 1000,
        minute: 60 * 1000,
        second: 1000,
    };

    const jsDate: number = date * 1000;
    const rtf = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });

    const getRelativeTime = (d1 = Math.floor(new Date().getTime() / 1000), d2 = jsDate) => {
        const elapsed = d2 - d1;

        for (const u in units) {
            if (Math.abs(elapsed) > units[u] || u === 'second')
                return rtf.format(
                    Math.round(elapsed / units[u]),
                    u as 'day' | 'days' | 'hour' | 'hours' | 'minute' | 'minutes' | 'second' | 'seconds'
                );
        }

        return (
            <time dateTime={jsDate.toString()} className={className}>
                {getRelativeTime(+new Date())}
            </time>
        );
    };

    return (
        <time dateTime={jsDate.toString()} className={className}>
            {getRelativeTime(+new Date())}
        </time>
    );
}
